function checkCyclic(item) {
  const seenObjects = new WeakSet();

  function detect(obj) {
    if (obj && typeof obj === "object") {
      if (seenObjects.has(obj)) {
        return true;
      }
      seenObjects.add(obj);

      if (Array.isArray(obj)) {
        return obj.some((value) => detect(value));
      }
      return Object.values(obj).some((value) => detect(value));
    }
    return false;
  }

  return detect(item);
}

export function setter(vm, item, fieldCode, value) {
  console.log(`[${new Date().toISOString()}] Setting field:`, {
    fieldCode: fieldCode,
    value: value,
  });

  if (checkCyclic(value)) {
    var msg = "Cyclic reference detected in value: " + fieldCode;
    console.warn(msg);
    vm.$emit("error", msg);
  }

  vm.$set(item, fieldCode, value);
}
